import EntryProxy from '@/app/proxies/EntryProxy';

export default {
    namespaced: true,
    state: {
        scores: [
        ]
    },

    getters: {
        all: state => state.scores.slice( 0, 5 ),
        place: state => ( relativeScore ) => state.scores.filter( ( el ) => el.score > relativeScore ).length + 1,
        highscore: state =>
        {
            return state.scores && state.scores[0] ? state.scores[0].score : 0;
        }
    },

    mutations: {
        scores: ( state, payload ) =>
        {
            state.scores = payload;
        }
    },

    actions: {
        load: ( context ) =>
        {
            return new EntryProxy()
                .all()
                .then( response =>
                {
                    context.commit( 'scores', response );
                    return response;
                })
                .catch( error =>
                {
                    return Promise.reject( error );
                });
        }
    }
};
